export class VideoListRequest {
  page: number = 0;
  page_size: number = 19;
}

export class SharedVideoRequest {
  owner_id: string;
  page: number = 0;
  page_size: number = 19;
}
